import Immutable from 'immutable';
import httpClient from 'superagent';
import AuthApi from 'app/api/AuthApi';
import AuthConstants from 'app/constants/AuthConstants';
import { selectFeatureStatuses } from 'app/selectors/FeatureTogglzSelector';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

function loadUser() {
  return {
    types: [
      AuthConstants.AUTH_LOAD_USER_REQUEST,
      AuthConstants.AUTH_LOAD_USER_SUCCESS,
      AuthConstants.AUTH_LOAD_USER_FAILURE
    ],
    apiRequest: (state, client) => AuthApi.loadUser(client)
  };
}

function login(username, password) {
  return {
    messaging: false,
    types: [AuthConstants.AUTH_LOGIN_REQUEST, AuthConstants.AUTH_LOGIN_SUCCESS, AuthConstants.AUTH_LOGIN_ERROR],
    apiRequest: (state, client) => AuthApi.login({ username, password, destination: window.location.href }, client),
    apiSuccess: (response, store) => {
      const features = selectFeatureStatuses(store.getState());
      if (features.get(TOGGLZ_FEATURES.CORE_WEB_SSO)) {
        return {
          forceRedirectURL: response.ssoUrl || window.location.href
        };
      }

      if (response.ssoUrl?.indexOf('https') === 0) {
        // We don't care about the result of the SSO request.
        // It shouldn't affect the user from logging in on our end
        httpClient
          .get(response.ssoUrl)
          .withCredentials()
          .end();
      }

      return {};
    },
    postSuccess: state => {
      const features = selectFeatureStatuses(state);
      if (!features.get(TOGGLZ_FEATURES.CORE_WEB_SSO)) {
        const postLoginAction = state.getIn(['auth', 'postLoginAction']);
        if (Immutable.Iterable.isIterable(postLoginAction)) {
          return postLoginAction.toJS();
        }

        return postLoginAction;
      }

      return undefined;
    }
  };
}

function logout() {
  return {
    type: AuthConstants.AUTH_LOGOUT
  };
}

function closeLoginDialog() {
  return {
    type: AuthConstants.CLOSE_LOGIN_DIALOG
  };
}

export default {
  login,
  logout,
  loadUser,
  closeLoginDialog
};
